import Bowser from 'bowser-ultralight';
import memoizeOne, { type MemoizedFn } from 'memoize-one';

import { getWindowObject } from '../utils/get-window-object';

export const eventBrowserPlugin: MemoizedFn<
	() => {
		'event:browser:name': string;
		'event:browser:version': string;
	} | null
> = memoizeOne(
	(): {
		'event:browser:name': string;
		'event:browser:version': string;
	} | null => {
		if (!Bowser.getParser) {
			return null;
		}
		const browser = Bowser.getParser(getWindowObject()?.navigator?.userAgent || '');
		return {
			'event:browser:name': browser.getBrowserName(),
			'event:browser:version': browser.getBrowserVersion(),
		};
	},
);
